import { Box, Typography } from '@mui/material';

const AuthFormHeader = () => {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px' }}>
            <Typography
                component="h1"
                sx={{
                    fontSize: '32px',
                    fontWeight: '600',
                    lineHeight: '40px',
                    textAlign: 'center',
                    textWrap: 'balance',
                }}
            >
                Welcome to Worko
            </Typography>
            <Typography sx={{ textAlign: 'center', textWrap: 'balance' }}>Your place to find people</Typography>
        </Box>
    );
};

export default AuthFormHeader;
